module.exports = __webpack_public_path__ + "static/img/20240809_2.951cfb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240809_2.png
// module id = 3kTZ
// module chunks = 0